import label from "../constant/label";
import ApiValues from "./ApiValues";
import ApiAccess from './ApiAccess';
var axios = require('axios');
function DepitTransaction(data) {
  console.log(data,"data")
    return ApiAccess.PostAxios(ApiValues.GetDepitTransaction , data).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": label.messages.apiError }
    });
}

export default DepitTransaction